module.exports = __webpack_public_path__ + "img/hotel-nh-campo-grande.3300a73e.jpg";